import script from "./NoticeCms.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeCms.vue?vue&type=script&setup=true&lang=js"

import "./NoticeCms.vue?vue&type=style&index=0&id=66ad46ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66ad46ae"]])

export default __exports__